const genderEnum = [
  'male',
  'female',
]

export default {
  type: String,
  enum: genderEnum,
};

// Named export for ESM builds
export {genderEnum as enum};
